export default __webpack_public_path__ + "static/abhaziya-celo-pskhu-cerkov-useknoveniya-glavy-ioanna-predtechi_10-294e2e8fcd9a91e3b22a19716d3ac501.jpg";